import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import { ReleaseMetricScore } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import styled from "styled-components";

// Dimension section

export const DimensionList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DimensionSection = styled.div<{ $hasDivider?: boolean }>`
  display: flex;
  flex-direction: row;
  padding: 1.2rem 0;
  border-top: ${({ $hasDivider }) => ($hasDivider ? `1px solid ${vars.colors.grey90}` : "none")};
  gap: 1.6rem;
`;

export const DimensionScoreAndName = styled.div`
  display: flex;
  align-items: flex-start;
  padding-left: 1.2rem;
`;

export const DimensionScoreAndNameInner = styled.div`
  display: flex;
  align-items: center;
`;

export const DimensionScore = styled(ReleaseMetricScore)`
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  border-radius: 0.6rem;

  p {
    font-weight: 600;
    font-size: 11.2px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
  }
`;

export const DimensionIconWrapper = styled.span`
  display: flex;
  align-items: center;

  svg {
    width: 2rem;
    height: 2rem;
    color: ${vars.colors.grey40};
    path {
      stroke: ${vars.colors.grey40};
    }
  }
`;

export const DimensionName = styled(Paragraph)`
  color: ${vars.colors.grey30};
  font-weight: 500;
  min-width: 8.4rem;
  max-width: 8.4rem;
  flex: 1;
  word-wrap: break-word;
`;

// Category rows

export const CategoryRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 3;
  min-width: 0;
`;

export const CategoryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex: 1;
`;

export const CategoryRowCell = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
`;

// Category chip

export const CategoryChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  border: 1px solid ${vars.colors.grey90};
  background: ${vars.colors.grey100};
  border-radius: 1rem;
  padding: 0.4rem 0.9rem;
  overflow: hidden;
  max-width: 100%;
`;

export const CategoryChipValueCount = styled(Paragraph)`
  color: ${vars.colors.grey30};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
`;

export const CategoryChipMinimumCount = styled(Paragraph)`
  color: ${vars.colors.grey60};
  font-style: italic;
`;

// Session text

export const SessionsText = styled(Paragraph)`
  min-width: 9rem;
  color: ${vars.colors.grey40};
  word-wrap: break-word;
`;

// Percentage bar

export const PercentageBar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
  justify-content: flex-end;
`;

export const PercentageText = styled(Paragraph)`
  text-align: center;
  border: 1px solid ${vars.colors.grey100};
  border-radius: 2rem;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.8rem;
  min-width: 5.1rem;
`;

export const PercentageBarTrack = styled.div`
  width: 8rem;
  display: flex;
  height: 1rem;
  background: ${vars.colors.skyDark};
  border-radius: 0.6rem;
  overflow: hidden;
  flex: 0 0 8rem;
`;

export const PercentageBarFill = styled.div<{ $pct: number }>`
  width: ${(p) => p.$pct}%;
  background: ${vars.colors.sky};
  height: 100%;
  border-right: 2px solid #2c2c2e54;
`;
